import Badge from 'antd/lib/badge'

import 'antd/lib/badge/style'

export * from 'antd/lib/badge'

export default Badge
